



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {gsap} from '@/utils/gsap';

enum cards {
	VISA
}

@Component({})
export default class AnimatedCards extends Vue {
	@Prop({required: true}) readonly name: string;

	tl: any = null;

	activeRefs: any = [];
	symbolsCards: string[] = ['visa'];


	cardsTransform: any = [
		{
			id: 0,
			default: {
				xPercent: -22,
				yPercent: 34,
				rotate: -10
			},
			open: {
				transform: 'translate(-61%, 50%, 0) rotate(-10deg);'
			}
		}
	];

	$refs: {
		card: HTMLElement[]
	}

	get cardsIncluded(): any {
		return this.$store.state.animationCards[`${this.name}`];
	}

	@Watch('cardsIncluded')
	onCardsIncludedChanged(newValue: any): void {
		if (!newValue) {
			return;
		}

		this.setCardIndex();
	}

	async mounted(): Promise<void> {
		if (typeof window === 'undefined') {
			return;
		}

		await this.$store.dispatch('updateAnimationCardsName', {
			key: this.name,
			state: ['']
		});

		await this.setCardIndex();
	}

	setCardIndex(): void {
		this.animInCard();
	}

	animInCard(): void {

		this.$refs.card.forEach((item: any, itemIndex: number) => {
			const isExist = this.cardsIncluded.includes(item.dataset.card.toUpperCase())

			if (isExist) {
				let styles = this.cardsTransform[itemIndex].open;
				gsap.to(item, {
					duration: 0.3,
					xPercent: styles.xPercent,
					yPercent: styles.yPercent,
					rotate: styles.rotate
				});
			} else {
				let styles = this.cardsTransform[itemIndex].default;
				gsap.to(item, {
					duration: 0.3,
					xPercent: styles.xPercent,
					yPercent: styles.yPercent,
					rotate: styles.rotate
				});
			}
		});
	}

	async beforeDestroy(): Promise<void> {
		await this.$store.dispatch('updateAnimationCardsName', {
			key: this.name,
			state: ['']
		});
	}

}
